import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { useEvent } from "shared/lib/useEvent"

import { useFavoriteMutations } from "entities/favorites/api/useFavoriteMutations"

import { DeleteFavoritesOverlayModel } from "../DeleteFavoritesOverlay"
import { DeleteFavoritesOverlayConnectorProps } from "../DeleteFavoritesOverlayConnector"

export const useDeleteFavoritesOverlayModel = ({
  payload: { itemIDsToDelete }
}: DeleteFavoritesOverlayConnectorProps): DeleteFavoritesOverlayModel => {
  const { closeOverlay } = useCurrentOverlay()
  const { deleteFavorite } = useFavoriteMutations()

  const handleDelete = useEvent(() => {
    closeOverlay()
    return Promise.all(itemIDsToDelete.map(id => deleteFavorite({ id })))
  })

  return {
    confirm: handleDelete,
    closeOverlay
  }
}
